import { useSnapshot } from 'valtio'
import { appState } from '../store'
import React, { useState } from 'react'
import useApi from '../hooks/useApi'
import {AiFillSave} from "react-icons/ai";
import {ApiError, CloseMatch} from "../@backend";
import { Btn } from '../ui/ds/Btn';
import { Badge } from '../ui/ds/Badge';
import { ScoreInput } from '../ui/ds/ScoreInput';

export default function CloseMatchModal() {
  const appSnap = useSnapshot(appState);
  const { backend } = useApi(true);

  const [homeScore, setHomeScore] = useState('0');
  const [awayScore, setAwayScore] = useState('0');
  const [overtime, setOvertime] = useState(false);
  const [overtimeHomeScore, setOvertimeHomeScore] = useState('0');
  const [overtimeAwayScore, setOvertimeAwayScore] = useState('0');
  const [formErrors, setFormErrors] = useState<string[]>([]);

  const match = appSnap.selectedMatch;

  const close = () => {
    appState.modals.showCloseMatchModal = false;
  };

  const scoreValue = (value: string) => Number(value || 0);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setFormErrors([]);
      const closeMatch = {
        id: match.id,
        scoreHomeTeam: scoreValue(homeScore),
        scoreAwayTeam: scoreValue(awayScore),
      } as CloseMatch;

      if(overtime) {
        closeMatch.overtime = true;
        closeMatch.overtimeScoreHomeTeam = scoreValue(overtimeHomeScore);
        closeMatch.overtimeScoreAwayTeam = scoreValue(overtimeAwayScore);
      }

      await backend.matches.matchControllerCloseMatch(closeMatch);
      appState.modals.showCloseMatchModal = false;
      appState.matches = await backend.matches.matchControllerGetAllMatchesPersonalized(Number(process.env.REACT_APP_ACTIVE_TOURNAMENT_ID));
      setHomeScore('0');
      setAwayScore('0');
      setOvertime(false);
      setOvertimeHomeScore('0');
      setOvertimeAwayScore('0');
    } catch (e: any) {
      if(e instanceof ApiError) {
        setFormErrors([e.body.error.message]);
        return;
      }
      setFormErrors(['Zápas se nepodařilo uložit. Zkuste to prosím znovu.']);
    }
  };

  if(!appSnap.modals.showCloseMatchModal || !match) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 py-8 overflow-y-auto"
      onClick={close}
    >
      <div
        className="bg-bg-card rounded-hero shadow-card w-full max-w-lg overflow-hidden my-auto"
        onClick={e => e.stopPropagation()}
      >
        <div className="bg-gradient-header px-6 py-5">
          <h2 className="tb-h2 text-white">Uzavření zápasu</h2>
          <p className="tb-caption text-white/70">
            {match.teamHome?.nameCountry} vs {match.teamAway?.nameCountry}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="px-6 py-6 flex flex-col gap-5">
          {formErrors.length > 0 && (
            <div
              className="flex items-center gap-3 bg-semantic-danger/10 border border-semantic-danger/20 rounded-content px-4 py-3"
              role="alert"
            >
              <Badge variant="danger">Chyba</Badge>
              <span className="tb-body text-semantic-danger">{formErrors.join(', ')}</span>
            </div>
          )}

          <div className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] gap-3 items-start">
            <div className="flex flex-col items-center gap-3 rounded-card bg-bg-inputSoft border border-border-neutral px-3 py-4">
              <img
                src={'/images/flags/' + match.teamHome?.flag}
                alt={match.teamHome?.name}
                className="w-24 h-16 sm:w-28 sm:h-20 object-contain"
              />
              <div className="tb-h4 text-text-primary text-center min-h-[40px] flex items-center">
                {match.teamHome?.nameCountry}
              </div>
              <ScoreInput value={homeScore} onChange={setHomeScore} />
            </div>

            <div className="tb-micro text-text-muted pt-20">VS</div>

            <div className="flex flex-col items-center gap-3 rounded-card bg-bg-inputSoft border border-border-neutral px-3 py-4">
              <img
                src={'/images/flags/' + match.teamAway?.flag}
                alt={match.teamAway?.name}
                className="w-24 h-16 sm:w-28 sm:h-20 object-contain"
              />
              <div className="tb-h4 text-text-primary text-center min-h-[40px] flex items-center">
                {match.teamAway?.nameCountry}
              </div>
              <ScoreInput value={awayScore} onChange={setAwayScore} />
            </div>
          </div>

          <div className="rounded-card border border-border-neutral bg-bg-inputSoft px-4 py-3">
            <label htmlFor="close-match-overtime" className="flex items-center gap-3 cursor-pointer">
              <input
                id="close-match-overtime"
                type="checkbox"
                checked={overtime}
                onChange={e => setOvertime(e.target.checked)}
                className="w-4 h-4 accent-brand-blue flex-shrink-0"
              />
              <span className="tb-body text-text-primary">Prodloužení</span>
            </label>

            {overtime && (
              <div className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] gap-3 items-center mt-4 pt-4 border-t border-border-neutral">
                <div className="flex justify-center">
                  <ScoreInput value={overtimeHomeScore} onChange={setOvertimeHomeScore} />
                </div>
                <div className="tb-micro text-text-muted">PP</div>
                <div className="flex justify-center">
                  <ScoreInput value={overtimeAwayScore} onChange={setOvertimeAwayScore} />
                </div>
              </div>
            )}
          </div>

          <div className="flex gap-3 pt-1">
            <Btn type="button" variant="ghost" size="sm" fullWidth onClick={close}>
              Zrušit
            </Btn>
            <Btn type="submit" variant="primary" size="sm" fullWidth icon={<AiFillSave />}>
              Uložit
            </Btn>
          </div>
        </form>
      </div>
    </div>
  )
}
